<template>
  <div
    id="teamDetails"
    class="mainCard"
  >
    <div class="data">
      <el-page-header
        :title="$t('common.goBack')"
        :content="null"
        @back="$router.go(-1)"
      />

      <el-card
        v-loading="loading"
        shadow="hover"
        class="clear-card teamCard"
        :body-style="{padding: '20px 0'}"
      >
        <div v-if="team">
          <div class="teamName">
            <span v-if="!editTeamName">
              {{ team.name }}
            </span>
            <el-button
              v-if="!editTeamName"
              class="inputBtn"
              type="text"
              @click="startEditName"
            >
              <i class="el-icon-edit"></i>
            </el-button>

            <div
              class="editWrap"
              :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
            >
              <el-input
                v-if="editTeamName"
                ref="teamNameInput"
                v-model="nameInput"
              />
              <div
                class="buttonWrap"
                :class="['mobile', 'tablet'].includes($mq) ? 'mobileMode' : 'deskMode'"
              >
                <el-button
                  v-if="editTeamName"
                  class="cancelInputBtn"
                  round
                  type="plain"
                  :loading="processSave"
                  @click="saveTeamName"
                >
                  {{ $t('common.save') }}
                </el-button>
                <!--<el-button
                  v-if="editTeamName"
                  class="cancelInputBtn"
                  round
                  type="primary"
                  @click.stop.prevent="cancelInput"
                >
                  {{ $t('common.cancel') }}
                </el-button>-->
              </div>
            </div>
          </div>

          <div class="leaderList">
            <el-table
              :data="team['member_list']"
              style="width: 100%;"
              class="mangerList clear-table"
            >
              <el-table-column
                :label="$t('common.name')"
                width="250"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.first_name || scope.row.last_name">
                    {{ `${scope.row.first_name} ${scope.row.last_name}` }}
                  </span>
                  <span v-else>
                    -
                  </span>
                </template>
              </el-table-column>

              <el-table-column
                prop="email"
                :label="$t('common.email')"
                width="300"
              />

              <el-table-column
                prop="status"
                :label="$t('oa.leader.status')"
              >
                <template slot-scope="scope">
                  {{ scope.row.is_active ? $t('oa.leader.active') : $t('oa.leader.inactive') }}
                </template>
              </el-table-column>

              <el-table-column class-name="actionCol">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.status === 'pending' || scope.row.status === 'expired'"
                    class="layout"
                  >
                    <div class="left">
                      <el-tooltip
                        class="item"
                        effect="light"
                        :content="$t('oa.team.resendEmailTooltip')"
                        placement="bottom-start"
                      >
                        <el-button
                          icon="el-icon-message"
                          circle
                          @click="resendEmail(scope.row.email)"
                        />
                      </el-tooltip>
                    </div>

                    <div>
                      <el-button
                        icon="el-icon-delete"
                        circle
                        @click="deleteTempUser(scope.row.email)"
                      />
                    </div>
                  </div>

                  <div
                    v-else
                    class="layout"
                  >
                    <div class="right">
                      <el-button
                        v-if="scope.row.uuid"
                        round
                        @click="goToUserPage('leader', scope.row.uuid)"
                      >
                        {{ $t('common.view') }}
                      </el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div
          v-else
          class="noData"
        >
          {{ $t('oa.team.noDetailData') }}
        </div>
      </el-card>

      <InvitationList
        v-if="team"
        :team="team"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api';
import InvitationList from './InvitationList.vue';

export default {
  components: {
    InvitationList,
  },

  filters: {
    formatStatus(value) {
      if (value === true) {
        return 'Active';
      } if (value === false) {
        return 'Deactivated';
      }
      return '-';
    },
  },

  data() {
    return {
      team: null,
      userForm: {
        sponsor: {
          email: '',
        },
        leader: {
          email: '',
        },
      },
      rules: {
        email: [
          { required: true, message: this.$t('common.rule.email.required'), trigger: 'blur' },
          {
            type: 'email',
            message: this.$t('common.rule.email.correct'),
            trigger: ['blur'],
          },
        ],
      },
      editTeamName: false,
      nameInput: '',
      loading: false,
      processSave: false,
    };
  },

  created() {
    this.getTeam();
  },

  methods: {
    async getTeam() {
      try {
        this.loading = true;
        const response = await api.getTeamDetails(this.$route.params.id);
        this.team = response.data;
        this.loading = false;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
        this.loading = false;
      }
    },

    openModal(role) {
      this.addUserModal = true;
      this.addUserRole = role;
    },

    addUser(users) {
      const u = users.map((el) => {
        const e = el;
        if (!e.status) e.status = 'pending';
        return e;
      });
      this.team.member_list.push(...u);
    },

    async resendEmail(email) {
      try {
        await api.resendEmailConfirmation(email);
        this.$message({
          type: 'success',
          message: this.$t('oa.team.emailResent'),
        });
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },

    async deleteTempUser(email) {
      this.$confirm(email, {
        title: this.$t('oa.team.confirmDeleteUser'),
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.goBack'),
      }).then(async () => {
        try {
          await api.deleteTempUser(email);
          this.team.leader = this.team.leader.filter(
            (el) => el.status !== 'pending' || el.email !== email,
          );
          this.$message({
            type: 'success',
            message: this.$t('oa.team.accountDeleted'),
          });
        } catch (err) {
          if (err.msg) {
            this.$message.error(err.msg);
          }
        }
      }).catch(() => {});
    },

    goToUserPage(role, id) {
      this.$router.push({ name: 'leaderDetail', params: { id } }).catch((err) => {});
    },

    startEditName() {
      this.editTeamName = true;

      this.nameInput = '';
      setTimeout(() => {
        this.nameInput = this.team.name;
        this.$refs.teamNameInput.focus();
      }, 100);
    },

    async saveTeamName() {
      if (this.nameInput !== this.team.name) {
        try {
          this.processSave = true;
          const response = await api.updateTeamDetails(this.team.uuid, {
            name: this.nameInput,
          });
          this.team.name = response.data.name;
          this.$message.success(this.$t('oa.team.teamUpdated'));
          this.editTeamName = false;
        } catch (err) {
          if (err.msg) {
            this.$message.error(err.msg);
          }
        } finally {
          this.processSave = false;
        }
      } else {
        this.editTeamName = false;
      }
    },

    cancelInput() {
      this.nameInput = this.team.name;
      this.editTeamName = false;
    },
  },
};
</script>

<style lang="scss" scoped>
  #teamDetails {
    .noData {
      padding: 0 30px;
    }

    .teamCard {
      text-align: left;
      margin-bottom: 20px;

      .teamName {
        font-weight: bold;
        font-size: 20px;
        padding: 0 20px 10px;

        .inputBtn {
          color: var(--themeFontColor);
          padding: 0;
        }

        .cancelInputBtn {
          margin-left: 20px;
          width: 100px;
        }

        .editWrap {
          display: flex;
          flex-wrap: wrap;

          &.mobileMode {
            .el-input {
              width: 100%;
            }
          }

          .buttonWrap {
            &.mobileMode {
              display: flex;
              padding: 10px 0;
              width: 100%;
              justify-content: center;

              .el-button {
                width: 50%;
                margin: 0 10px;
              }
            }
          }
        }
      }

      .leaderList {
        .groupName {
          font-weight: bold;
        }
      }
    }

    .addUserBtn {
      background-color: transparent;
      border: 1px dashed var(--themeFontColor);
      color: var(--themeFontColor);
      cursor: pointer;
      margin-top: 15px;
      height: 68px;
      line-height: 68px;
      border-radius: 10px;
      text-align: center;

      &:hover {
        background-color: rgba(255, 255, 255, 0.3);
      }
    }
  }
</style>

<style lang="scss">
  #teamDetails {
    .teamCard {
      .teamName {
        .el-input {
          width: 50%;

          .el-input__inner {
            background-color: transparent;
            border-radius: 0;
            border-left-width: 0;
            border-top-width: 0;
            border-right-width: 0;
            border-bottom-color: var(--themeFontColor) !important;
            color: var(--themeFontColor);
            padding-left: 5px;
            font-size: 20px;
            font-weight: bold;
          }
        }
      }

      .leaderList {
        .cell {
          word-break: initial;
        }

        .el-table__row {
          height: 62px;
        }

        tr {
          & > th:first-child,
          & > td:first-child {
            .cell {
              padding-left: 20px;
            }
          }
        }

        & > div:not(.el-table) {
          padding-left: 20px;
          padding-right: 20px;
        }

        &.roleManager {
          margin-bottom: 50px;
        }

        .el-table {
          background-color: transparent;
          border-radius: 0;

          &:hover {
            box-shadow: unset;
          }

          .actionCol {
            .layout {
              display: flex;
              justify-content: space-around;
              flex-wrap: wrap;

              .el-button {
                background: transparent;
                color: var(--themeFontColor);
                border-width: 0;
                padding: 13px 15px;

                &:hover {
                  background: #409eff;
                  border-color: #409eff;
                  color: white;
                }
              }

              .right {
                .el-button {
                  display: block;
                  border-width: 1px;
                  padding-top: 11px;
                  max-height: 38px;
                }
              }
            }
          }

          tr:hover .actionCol .layout .right .el-button {
            max-height: 38px;
          }
        }
      }
    }
  }
</style>
